export default "__VITE_ASSET__CtjjHdjo__"